import { axios } from '@Root/API'

export const remove = id => {
	return axios.delete(`institutions/${id}`)
}
